import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { CarCareCategory, CarCareCategoryQueryParams } from "../types";

interface CarCareCategoryState {
  carCareCategories: Array<CarCareCategory>;
  carCareCategoriesTotal: number;
  carCareCategory?: CarCareCategory;
}

const initialState: CarCareCategoryState = {
	carCareCategories: [],
	carCareCategoriesTotal: 0,
};

export const carCareCategorySlice = createSlice({
	name: "carCareCategory",
	initialState,
	reducers: {
		setCarCareCategorys: (state, action) => {
			state.carCareCategories = action.payload.data;
			state.carCareCategoriesTotal = action.payload.total;
		},
		setCarCareCategory: (state, action) => {
			state.carCareCategory = action.payload.data;
		},
		changeStatusCarCareCategory: (state, action) => {
			const { id, status } = action.payload;
			const index = state.carCareCategories.findIndex(el => el._id === id);
			state.carCareCategories[index].status = status;
		},
	},
});

export const selectCarCareCategorys = (state: RootState) => state.carCareCategory.carCareCategories;
export const selectCarCareCategorysTotal = (state: RootState) => state.carCareCategory.carCareCategoriesTotal;
export const selectCarCareCategory = (state: RootState) => state.carCareCategory.carCareCategory;

export const { setCarCareCategorys, setCarCareCategory, changeStatusCarCareCategory } = carCareCategorySlice.actions;

export interface GetCarCareCategorysAsyncPayload {
  query: CarCareCategoryQueryParams;
	callback?: () => void;
}
export interface GetCarCareCategoryDetailsPayload {
  id: string;
	callback?: (carCareCategory?: CarCareCategory) => void;
}
export interface CreateCarCareCategoryPayload {
  data: CarCareCategory;
  callback: () => void;
}
export interface UpdateCarCareCategoryPayload {
  id: string;
  data: CarCareCategory;
	callback?: () => void;
}

export interface UpdateCarCareCategoryStatusPayload {
  id: string;
  status: string;
	callback?: () => void;
}

export const getCarCareCategorysAsync = createAction(
	"carCareCategory/getCarCareCategorys",
	(payload: GetCarCareCategorysAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const getCarCareCategoryDetailsAsync = createAction(
	"carCareCategory/getCarCareCategoryDetails",
	(payload: GetCarCareCategoryDetailsPayload) => ({
		payload: payload,
	})
);

export const createNewCarCareCategoryAsync = createAction(
	"carCareCategory/createNewCarCareCategory",
	(payload: CreateCarCareCategoryPayload) => ({
		payload: payload,
	})
);

export const updateCarCareCategoryAsync = createAction(
	"carCareCategory/updateCarCareCategory",
	(payload: UpdateCarCareCategoryPayload) => ({
		payload: payload,
	})
);



export default carCareCategorySlice.reducer;
